import script from "./CareerPathChatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerPathChatbot.vue?vue&type=script&setup=true&lang=js"

import "./CareerPathChatbot.vue?vue&type=style&index=0&id=4e7484d9&lang=css"

const __exports__ = script;

export default __exports__